import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var TypeMapper =
/*#__PURE__*/
function () {
  function TypeMapper() {
    _classCallCheck(this, TypeMapper);
  }

  _createClass(TypeMapper, [{
    key: "mapSingleType",
    value: function mapSingleType(response) {
      return this.mapType(response);
    }
  }, {
    key: "mapMultipleTypes",
    value: function mapMultipleTypes(response) {
      var that = this;
      return response.types.map(function (type) {
        return that.mapType(type);
      });
    }
  }, {
    key: "mapType",
    value: function mapType(type) {
      if (!type) {
        throw Error("Cannot map type");
      }

      if (!type.elements) {
        throw Error("Cannot map type elements");
      }

      var system = {
        codename: type.system.codename,
        id: type.system.id,
        name: type.system.name,
        lastModified: type.system.last_modified
      };
      var elements = [];
      var elementNames = Object.getOwnPropertyNames(type.elements);
      elementNames.forEach(function (elementName) {
        var typeElement = type.elements[elementName];

        if (!typeElement) {
          throw Error("Cannot find element '".concat(elementName, "' on type '").concat(type, "'"));
        } // use json property as a codename of the type element


        var elementCodename = elementName; // extra properties for certain element types

        var taxonomyGroup = typeElement.taxonomy_group;
        var options = []; // some elements can contain options

        var rawOptions = typeElement.options;

        if (rawOptions) {
          if (!Array.isArray(rawOptions)) {
            throw Error("Content type 'options' property has to be an array");
          }

          rawOptions.forEach(function (rawOption) {
            options.push({
              codename: rawOption.codename,
              name: rawOption.name
            });
          });
        }

        elements.push({
          codename: elementCodename,
          taxonomyGroup: taxonomyGroup,
          options: options,
          name: typeElement.name,
          type: typeElement.type
        });
      });
      return {
        elements: elements,
        system: system
      };
    }
  }]);

  return TypeMapper;
}();